import React, { Suspense, lazy, useMemo } from "react";

const DynamicComponentsRenderer = ({
  components,
  customizedContents,
  keyData,
  modifyMode,
  setIsLoadingModal,
  handleChangeToSave,
  row,
  componentsToFormId,
  dynamicState,
  approvalData,
  keyArray,
  activeMenu,
  styleSettings,
  showAdditionalInfo,
  interComponentData,
  setInterComponentData,
  gradePrivacyState,
  lastYearPrivacyState,
  maskKoreanId,
}) => {
  const Component = useMemo(
    () =>
      lazy(() =>
        import(
          `./${components.component_category}/${components.component_filename}`
        )
      ),
    [components.component_category, components.component_filename]
  );
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Component
        contents={customizedContents ? customizedContents : components.contents}
        keyData={keyData}
        modifyMode={modifyMode}
        setIsLoadingModal={setIsLoadingModal}
        handleChangeToSave={handleChangeToSave}
        row={row || {}}
        componentsToFormId={componentsToFormId}
        dynamicState={dynamicState}
        approvalData={approvalData}
        keyArray={keyArray}
        activeMenu={activeMenu}
        styleSettings={styleSettings}
        showAdditionalInfo={showAdditionalInfo}
        interComponentData={interComponentData}
        setInterComponentData={setInterComponentData}
        gradePrivacyState={gradePrivacyState}
        lastYearPrivacyState={lastYearPrivacyState}
        maskKoreanId={maskKoreanId}
      />
    </Suspense>
  );
};

export default DynamicComponentsRenderer;
